import * as Models from "../.";
import { IPaymentPlanSetupRequest } from "./PaymentPlanSetupRequest";

export interface IUpdatePaymentMethodSearchResult {
  name: string;
  address: string;
  phoneNumber: string;
  email: string;
  abpAccountNumber: string;
  lineOfBusiness: string;
}
export class UpdatePaymentMethodSearchResult
  implements IUpdatePaymentMethodSearchResult {
  name: string;
  address: string;
  phoneNumber: string;
  email: string;
  abpAccountNumber: string;
  lineOfBusiness: string;
}

export class UpdatePaymentMethodFormControlVariables {
  hasSelectedAccountToUpdate = false;
  submittingUpdatePaymentMethod = false;
  hasSearchValues = false;
  hasPreformedSearch = false;
  hasSubmittedUpdatePaymentMethod = false;
  hasPaymentError = false;
  hasPaymentPlanError = false;
  editPaymentInformationOnly = false;
  customerPaymentInformationIsOnFile = false;
}

export class CollectPayUpdateOnlySlider {
  text = "Collect Payment";
  enabled = true;
}

export class AutoPayAuthSlider {
  text = "Authorize Auto Payment";
  enabled = false;
}

export class UpdatePaymentInformationCustomerDetailRequest {
  abpAccountNumber: string;
}

export class UpdatePaymentInformationCustomerDetailResponse {
  customer: Models.Customer.Customer.ICustomer;
  address: Models.Customer.Address.IAddress;
  ldcAccountNumber: string;
  abpAccountNumber: string;
  creditCardDisplay: CreditCardDisplay;
  achDisplay: AchDisplay;
  invoiceAmount: number;
  currentBalance: number;
  pastDue: number;
  isOnPaymentPlan: boolean;
  isEligibleForPaymentPlan: boolean;
  hasUnratedProduction: boolean;
  hasPendingInvoice: boolean;
  shouldDisplaySilenceCallRecording: boolean;
  hasActiveWriteOff: boolean;
}

export class CreditCardDisplay {
  lastFour: string;
  expirationMonth: number;
  expirationYear: number;
}

export class AchDisplay {
  lastFourAccount: string;
  routingNumber: string;
}

export class CollectionOption {
  text: string;
  amount: number;
}

export interface IUpdatePaymentInformationRequest {
  abpAccountNumber: string;
  amountToCollect: number;
  paymentInfo: Models.PaymentCapture.PaymentInfo.PaymentProfile;
  ldcAccountNumber: string;
  useExisting: boolean;
  autoPay: boolean;
  paymentPlanSetupRequest: IPaymentPlanSetupRequest;
}

export class UpdatePaymentInformationRequest
  implements IUpdatePaymentInformationRequest {
  abpAccountNumber: string;
  amountToCollect: number;
  paymentInfo: Models.PaymentCapture.PaymentInfo.PaymentProfile;
  ldcAccountNumber: string;
  useExisting: boolean;
  autoPay: boolean;
  paymentPlanSetupRequest: IPaymentPlanSetupRequest;
}

export class UpdatePaymentInformationResult {
  responseMessage: string;
  responseCode: number;
}

export interface IUpdatePaymentMethodSearchRequest {
  customer: Models.Customer.Customer.ICustomer;
  address: Models.Customer.Address.IAddress;
  accountNumber: string;
  invoiceNumber: string;
}

export class UpdatePaymentMethodSearchRequest
  implements IUpdatePaymentMethodSearchRequest {
  customer = new Models.Customer.Customer.CustomerInitialized();
  address = new Models.Customer.Address.AddressInitialized();
  accountNumber = "";
  invoiceNumber = "";
}
